import { Component, forwardRef, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ApiService } from '../../utils/services/api.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-agency-selection',
  templateUrl: './agency-selection.component.html',
  styleUrls: ['./agency-selection.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AgencySelectionComponent),
      multi: true
    }
  ]
})
export class AgencySelectionComponent implements OnInit, ControlValueAccessor, OnChanges {

  public agencies = [];
  public selectedID = null;

  @Input() selectedAgency = null;

  @Input() type = 'Agency';

  public propagateChange = (_: any) => {
  };

  constructor(private apiService: ApiService) {
  }

  ngOnChanges(simple: SimpleChanges) {
    if (simple.selectedAgency) {
      this.selectedID = null;
      this.apiService.getAgencyOrganizations(this.selectedAgency).subscribe(
        //this.apiService.getAgencyOrganizations(this.selectedAgency).subscribe( //eskisi
        response => {
          this.agencies = response['data'].rows.map(p => p.grantorOrganization);
        }, error => {
          console.log(":(");
        }
      );
    }
  }

  ngOnInit() {
    if (this.type === 'Organization' && this.selectedAgency) {
      this.apiService.getAgencyOrganizations(this.selectedAgency).subscribe(
        //this.apiService.getCrossOrganizations(this.selectedAgency).subscribe( //eskisi
        response => {
          this.agencies = response['data'].rows.map(p => p.grantorOrganization);
        }, error => {
          console.log(":(");
        }
      );
    } else
      this.apiService.getOrganizations(this.type).subscribe(
        response => {
          this.agencies = response['data'];
        }, error => {

        }
      );
  }

  writeValue(value: any) {
    this.selectedID = value;
  }

  onDataChanged(value) {
    this.propagateChange(value.split(':')[1].trim());
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/agency-selection/agency-selection.component.ts